import { applyFontFallbacksString } from '../font-utils';
export const handleFontFamilyFallbacks = (span) => {
    const fontFamily = span.css('font-family');
    if (fontFamily) {
        span.css('font-family', applyFontFallbacksString(fontFamily));
    }
};
//# sourceMappingURL=handle-font-family-fallbacks.js.map